var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.8C9.89355 6.8 11.4286 5.27777 11.4286 3.4C11.4286 1.52223 9.89355 0 8 0C6.10645 0 4.57143 1.52223 4.57143 3.4C4.57143 5.27777 6.10645 6.8 8 6.8Z",
    fill: "#889EBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17C1.34315 17 -0.0535776 15.6092 0.562805 14.0713C1.73786 11.1394 4.62484 9.06667 8 9.06667C11.3752 9.06667 14.2621 11.1394 15.4372 14.0713C16.0536 15.6092 14.6569 17 13 17H3Z",
    fill: "#889EBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d1b6d676.svg";
export { ForwardRef as ReactComponent };